exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-artist[data-v-6a4bbfea]{border:2px solid #42b983;border-radius:4px;display:inline-block;margin:20px;padding:10px}.list-artist img[data-v-6a4bbfea]{border-radius:5px}.listeners[data-v-6a4bbfea]{font-size:.8em;margin:0 0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a4bbfea","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Artist.vue
// module id = 19
// module chunks = 0